import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {BeatLoader} from 'react-spinners';
import moment from  'moment';
import NotificationSystem from 'react-notification-system';
import {_addNotification, _addNotificationError, 
    gradeTextToNumber,isRegularLunchOrderType, getSchoolGrades, groupBy} from "../../../../server/util";
import MonthDropdown from '../../../Misc/MonthDropdown';
import { get,postWithHeadersResponse,postWithHeaders } from '../../../../server/actions'
import {Doughnut} from 'react-chartjs-2';
import {MenuOrderTypes,MealTypesReports } from '../../../../server/constants';
import {getReportMenuOptions} from '../../../Misc/MenuOptions/menuOptionsActions';
var _ = require('lodash');
var converter = require('number-to-words');
const options={
    responsive: true,
    maintainAspectRatio: false,
    legend: {
        position: 'left',
        labels: {
          boxWidth: 8
        }
      },
      plugins: {
        datalabels: {
           display: true,
           color: 'white',
           font: { size: '10' },
        }
     }
}
let gradeList=[];
class OrderDoughnut extends Component {
    constructor(props){
        super(props); 
        let date = new Date();
        date.setMonth(date.getMonth())       
        this.state = {
            loading: false,
            date: date,
            selectedMonth: moment((this.props.activeMonth||moment()),'YYYYMM').format('MMM-YYYY'),
            selectedMonthDate:moment(),
            mealType:(getReportMenuOptions()[0]||''),
            activeMonth:null,
            chartObj:{
                labels: [],
                datasets: [{
                    data: [],
                    backgroundColor: [
                        '#FF6384',
                        '#36A2EB',
                        '#CD853F',
                        '#AF6382',
                        '#BC8F8F',
                        '#FFCE55',
                        '#A3A381',
                        '#3672BC',
                        '#FFDEAD',
                        '#FF6380',
                        '#1AAA22',
                        '#FF69B4',
                        '#808080'
                    ],
                    hoverBackgroundColor: [
                        '#FF6384',
                        '#36A2EB',
                        '#CD853F',
                        '#AF6382',
                        '#BC8F8F',
                        '#FFCE55',
                        '#A3A381',
                        '#3672BC',
                        '#FFDEAD',
                        '#FF6380',
                        '#1AAA22',
                        '#FF69B4',
                        '#808080'
                    ]
                }]
            },            
        }
        this.init=this.init.bind(this)
        this.getData=this.getData.bind(this);
    }
    componentWillMount=()=>{
        this.init();
    }
    componentWillReceiveProps=(nextProps)=> {
        if(this.state.activeMonth!==nextProps.activeMonth){
             this.setState({
                selectedMonth: moment((nextProps.activeMonth||moment()),'YYYYMM').format('MMM-YYYY')
            },this.getData(nextProps.activeMonth))                 
        }
    }
    init=()=>{
        let activeSession=this.props.activeMonth||moment().format('YYYYMM')
        this.getData(activeSession);
    }
    getData=(yearMonth)=>{  
        this.setState({loading: true});
        let selectedMonthYear=moment(this.state.selectedMonth||moment().format('MMM-YYYY'),'MMM-YYYY').format('YYYYMM');
        if(this.state.mealType===MealTypesReports.LUNCH ||
            this.state.mealType===MealTypesReports.SNACK){
        //const mType=(this.state.mealType===MealTypesReports.LUNCH) &&!isRegularLunchOrderType()?MenuOrderTypes.ITEMIZE:this.state.mealType;   
        //let yearMonth = (moment(this.state.date,'MM').format().split('-')[0])+ '' + (moment(this.state.date,'MM').format().split('-')[1]);
        get('/reports/countByGrade?isVersion2=true&mealSchoolId=' + sessionStorage.getItem('SchoolId') + '&menuType='+ this.state.mealType   + '&yearMonth=' + selectedMonthYear + '&schoolYear='+ sessionStorage.getItem('schoolYearValue') + '&access_token=').then((response) => {
           
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(respData => {
            console.log('data', respData);
            let orders = respData || {};
            let _chartObj=this.state.chartObj;            
            _chartObj.labels=[];
            _chartObj.datasets[0].data=[];
            const gradeGroup=groupBy(gradeList,'value');
            Object.keys(orders).map((key)=>{
                if(key==='ordered' ){
                    let grades=orders[key].countByGrades||{};
                    Object.keys(grades).map((grade)=>{  
                        const label=((gradeGroup[grade]||[])[0]||{}).label;
                        _chartObj.labels.push(label);
                        _chartObj.datasets[0].data.push(grades[grade]);
                    })
                }
            })
            this.setState({ chartObj:_chartObj,loading: false          
            })
        }).catch(
            (error) => {
                this.setState({loading: false})
                console.log('Get School data response', error)
            }
        );
        } 
    }
    
    render(){
        gradeList=getSchoolGrades(0,false);
        return(<div>
         <NotificationSystem ref="notificationSystem"/>     
         <div className="col-md-4"> 
         <div className='sweet-loading'
                     style={{position: 'absolute', top: '50%', left: '48%', zIndex: '1000'}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>     
         <div className="panel chart-panel">
            <div className="panel-heading text-center" style={{padding:'0px'}}>
                <span className="panel-title" style={{fontSize: '14px', fontWeight:'600'}}>{'Monthly Orders'}</span>
                <div className="pull-right">
                <MonthDropdown  dateFormat={'YYYYMM'} onChange={(e)=>{
                    this.setState({selectedMonth:moment(e).format('MMM-YYYY'),selectedMonthDate:moment(e)},()=>{
                        this.getData(moment(e).format('YYYYMM'))
                    })                     
                }} selectedMonth={moment(this.state.selectedMonth||moment(),'MMM-YYYY')} />
                </div>
                <p className="panel-title" 
                style={{fontSize: '12px', fontWeight:'600'}}>
                 {this.state.selectedMonth }</p>
            </div>
            <div className="panel-body" style={{padding:'0px'}}>        
                <Doughnut data={this.state.chartObj} options={options}
                 onElementsClick={elems => {
                    const gradeGroup=groupBy(gradeList,'label');
                     if(elems.length>0){
                        console.log(elems[0]._datasetIndex + ', ' + elems[0]._index);
                        const gradeValue=((gradeGroup[elems[0]._model.label]||[])[0]||{}).value;
                       let action='Ordered';
                        let selectedMonthYear=moment(this.state.selectedMonth||moment().format('MMM-YYYY'),'MMM-YYYY').format('YYYYMM');
                        this.props.onElementClick(gradeValue,action,selectedMonthYear)
                     }                    
                }} />
            </div>
            </div>
        </div>
        </div>)
    }
}
export default OrderDoughnut


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Home/DashboardCharts/orderDoughnut.jsx